import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

const NewList = () => {
  const [list, setList] = useState({ name: null })
  const [editingName, setEditingName] = useState(false)
  const [saving, setSaving] = useState(false)
  const navigate = useNavigate()

  const updateListName = (newName) => {
    setList(prevList => ({ ...prevList, name: newName }))
  }

  const saveList = () => {
    if (!list.name || list.name.trim() === '') {
      setEditingName(false)
      return
    }

    setSaving(true)
    axios.post('/api/lists', { list: { name: list.name } })
      .then(response => {
        const savedList = response.data
        setEditingName(false)
        setSaving(false)
        navigate(`/lists/${savedList.id}`)
      })
      .catch(error => {
        console.error('Error saving list:', error)
        setSaving(false)
        setEditingName(false)
      })
  }

  console.log('Rendering, list:', list)

  return (
    <>
      {editingName ? (
        <input
          type="text"
          value={list.name || ''}
          onChange={(e) => updateListName(e.target.value)}
          onBlur={() => saveList()}
          onKeyDown={(e) => { if (e.key === 'Enter') { saveList() } }}
          className="form-control form-control-lg"
          placeholder="Enter list name..."
          autoFocus
        />
      ) : (
        <h1
          onClick={() => setEditingName(true)}
          tabIndex={0}
          role="button"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setEditingName(true);
          }}
        >
          {list.name || 'Click to add name'}
        </h1>
      )}
    </>
  )
}

export default NewList
